import { render, staticRenderFns } from "./PosTable.vue?vue&type=template&id=70da6b66"
import script from "./PosTable.vue?vue&type=script&lang=js"
export * from "./PosTable.vue?vue&type=script&lang=js"
import style0 from "./PosTable.vue?vue&type=style&index=0&id=70da6b66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports